export const CLOSING_DE = {
  header: {
    title: 'Einstellung',
    subtitle:
      'Dieser Bereich fasst die <strong>Talente zusammen, die Ihr Angebot angenommen haben</strong>.<br/><br/>Abhängig von den Berechtigungen Ihres Kontos können auch Kostendetails und die zugehörige Dokumentation enthalten sein.',
  },
  bingoHeader: {
    label: 'Sie haben',
    sublabel: 'eingestellt',
  },
  links: {
    resignation_letter: 'Das Kündigungsschreiben',
    commitment_letter: 'Das Anstellungsanschreiben ',
    prospect: 'Siehe Berechnung',
  },
  tag: {
    text: 'Eingestellt am {{hiring_date}}',
  },
};
